import {load} from '@shopify/theme-sections';
import '../sections/product';
import '../sections/testimonials';
import '../sections/hero-index';

load('*');
